import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'WellViewReports';
  private readonly msalService = inject(MsalService);

  ngOnInit(): void {
    this.msalService.instance.initialize().then(() => {
      this.msalService.instance.handleRedirectPromise().then(result => {
        if (result?.account) {
          this.msalService.instance.setActiveAccount(result.account);
          return;
        }

        if (!environment.requireAuth) return;

        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
        } else {
          this.msalService.loginRedirect({ scopes: environment.auth.scopes });
        }
      });
    });
  }
}
